<template>
    <div class="zebra-crossing-detail">
        <el-form :model="detail">
            <div class="zebra-item">
                <div class="zebra-item_tit">资源规格</div>
                <el-row v-for="index in Math.ceil(attrData.length/2)">
                    <el-col :span="12">
                        <div  v-if=" typeof(attrData[(index-1)*2] )== 'undefined'">
                            <el-form-item label=""></el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item
                                v-if="attrData[(index-1)*2]['value_type'] == 'v_list'"
                                :label="attrData[(index-1)*2]['alias']+'：'">
                                {{  detail.specification[attrData[(index-1)*2]['name']].join(',') }}
                            </el-form-item>
                            <el-form-item
                                v-else-if="attrData[(index-1)*2]['value_type'] == 'v_int' && attrData[(index-1)*2]['form_type'] == 'integer'"
                                :label="attrData[(index-1)*2]['alias']+'：'">
                                {{  detail.specification[attrData[(index-1)*2]['name']] }}
                            </el-form-item>
                            <el-form-item
                                v-else-if="attrData[(index-1)*2]['form_type'] == 'select'&& attrData[(index-1)*2]['value_type'] == 'v_int'"
                                :label="attrData[(index-1)*2]['alias']+'：'">
                                {{  detail.specification[attrData[(index-1)*2]['name']] | getCname(dictionary[attrData[(index-1)*2]['ddt']]) }}
                            </el-form-item>
                            <el-form-item v-else
                                :label="attrData[(index-1)*2]['alias']+'：'">
                                {{  detail.specification[attrData[(index-1)*2]['name']] | getCname(dictionary[attrData[(index-1)*2]['ddt']]) }}
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div  v-if=" typeof(attrData[index+(index-1)] )== 'undefined'">
                            <el-form-item label=""></el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item
                                v-if="attrData[index+(index-1)]['value_type'] == 'v_list'"
                                :label="attrData[index+(index-1)]['alias']+'：'">
                                {{ detail.specification[attrData[index+(index-1)]['name']].join(',') }}
                            </el-form-item>
                            <el-form-item
                                v-else-if="attrData[index+(index-1)]['value_type'] == 'v_int' && attrData[index+(index-1)]['form_type'] == 'integer'"
                                :label="attrData[index+(index-1)]['alias']+'：'">
                                {{ detail.specification[attrData[index+(index-1)]['name']] }}
                            </el-form-item>
                            <el-form-item
                                v-else-if="attrData[index+(index-1)]['form_type'] == 'select'&& attrData[index+(index-1)]['value_type'] == 'v_int'"
                                :label="attrData[index+(index-1)]['alias']+'：'">
                                {{ detail.specification[attrData[index+(index-1)]['name']] | getCname(dictionary[attrData[index+(index-1)]['ddt']])}}
                            </el-form-item>
                            <el-form-item v-else
                                :label="attrData[index+(index-1)]['alias']+'：'">

                                {{ detail.specification[attrData[index+(index-1)]['name']] | getCname(dictionary[attrData[index+(index-1)]['ddt']]) }}
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    import commonService from "../../../services/common.service"
    import services from "../resourceApply.service";
    export default {
        props:{
            detail:Object,

        },
        data() {
            return {

            }
        },
        watch:{
            detail:{
                handler(newval){
                    console.log(newval)
                    console.log(this.attrData)
                },
                immediate:true
            },

        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },

            attrData(){

                return this.$store.state.resourceTypeAttr
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
    .zebra-crossing-detail .zebra-item .el-form-item__content a{
        float: left;
        margin-left: 20px;
    }
    .preview{
        color:blue;
        cursor: pointer;
        margin-left: 10px;
    }
</style>
